import React, { useRef, useState, useEffect } from "react";
import { Box, Stack, Chip } from "@mui/material";
import {CategoriesValue} from "../../../../../types/Card";
import CancelIcon from "@mui/icons-material/Cancel";

interface SubCategoriesProps {
  categoryData: CategoriesValue[];
  selectedCategory: string | null;
  selectedSubCategories: string[]; // ✅ changed from string | null
  handleSubCategoryClick: (slug: string) => void;
}

const SubCategories = (props: SubCategoriesProps) => {
  const {
    categoryData,
    selectedSubCategories,
    selectedCategory,
    handleSubCategoryClick,
  } = props;

  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [showLeftFade, setShowLeftFade] = useState(false);
  const [showRightFade, setShowRightFade] = useState(false);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeftFade(el.scrollLeft > 0);
    setShowRightFade(el.scrollWidth > el.clientWidth + el.scrollLeft);
  };

  useEffect(() => {
    checkScroll();
    const el = scrollRef.current;
    if (el) {
      el.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
    }
    return () => {
      if (el) el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  const subCategories =
    categoryData.find((cat) => cat.slug === selectedCategory)?.sub_categories ||
    [];

  // to make selected sub categories appear at the beginning
  // const originalSubCategories =
  //   categoryData.find((cat) => cat.slug === selectedCategory)?.sub_categories ||
  //   [];

  // const subCategories = [
  //   ...originalSubCategories.filter((sub) =>
  //     selectedSubCategories.includes(sub.slug)
  //   ),
  //   ...originalSubCategories.filter(
  //     (sub) => !selectedSubCategories.includes(sub.slug)
  //   ),
  // ];

  const more = { disableRipple: true };

  return (
    <Box sx={{ position: "relative", overflow: "hidden" }}>
      {showLeftFade && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: 40,
            height: "100%",
            background: "linear-gradient(to right, white, transparent)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        />
      )}
      {showRightFade && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: 40,
            height: "100%",
            background: "linear-gradient(to left, white, transparent)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        />
      )}
      <Stack
        direction="row"
        flexWrap="nowrap"
        ref={scrollRef}
        onScroll={checkScroll}
        sx={{
          overflowX: "auto",
          paddingX: 1,
          zIndex: 1,
          scrollBehavior: "smooth",
          pb: 4,
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        gap={1}
        mt={1}
        pb={2}
      >
        {subCategories.map((sub) => {
          const isSelected = selectedSubCategories.includes(sub.slug);
          return (
            <Chip
              key={sub.slug}
              label={sub.name}
              icon={
                isSelected ? (
                  <CancelIcon sx={{ path: { fill: "var(--neutralBlack)" } }} />
                ) : undefined
              }
              sx={{
                px: 1.5,
                py: 0.5,
                borderRadius: "20px",
                fontWeight: 500,
                fontSize: 14,
                flexDirection: "row-reverse",
                transition: "none",
                color: isSelected
                  ? "var(--neutralBlack)"
                  : "var(--neutral-300)",
                backgroundColor: "var(--neutralWhite)",
                border: isSelected
                  ? "1px solid var(--neutralBlack)"
                  : "1px solid var(--neutral-300)",
                "&:hover": {
                  ...(isSelected
                    ? {}
                    : {
                        border: "1px solid var(--neutralBlack)",
                        color: "var(--neutralBlack)",
                        transition: "none",
                      }),
                  backgroundColor: "var(--neutralWhite)",
                  boxShadow: "none",
                },
              }}
              onClick={() => handleSubCategoryClick(sub.slug)}
              {...more}
            />
          );
        })}
      </Stack>
    </Box>
  );
};

export default SubCategories;
